import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';

import CSIO_84 from '../../../assets/images/CSIO_84.png';
import CSIO_87 from '../../../assets/images/CSIO_87.png';

const MemberSurvey = () => (

  <Container>
    <Row>
      <Col xs={12} md={6} style={{marginTop: 60}}>
        <ConsiderTheir />
      </Col>
      <Col xs={12} md={6} style={{marginTop: 60}}>
        <Respondents />
      </Col>
    </Row>
  </Container>
)

const ConsiderTheir = () => (
  <Col>
    <Row>
      <Col xs={4}>
        <img
          src={CSIO_84}
          style={{
            width: '100%',
            height: 'auto'
          }}
          aria-label="84%"
        />
      </Col>
      <Col xs={8}>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          paddingLeft: 20,
          paddingRight: 20,
          lineHeight: 1.2,
        }}>consider their organizations to be 
        <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> digital businesses</span>. That's a<span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> 7% increase </span>over last year.
        </p>
      </Col>
    </Row>
  </Col>
)

const Respondents = () => (
  <Col>
    <Row>
      <Col xs={4}>
        <img
          src={CSIO_87}
          style={{
            width: '100%',
            height: 'auto'
          }}
          aria-label="87%"
        />
      </Col>
      <Col xs={8}>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          paddingLeft: 20,
          paddingRight: 20,
          lineHeight: 1.2,
        }}>of respondents rated their
        <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> awareness of digital trends </span>between good and excellent, a slight<span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> increase of 2% </span>over last year.
        </p>
      </Col>
    </Row>
  </Col>
)

export default MemberSurvey;
